import store from 'app-store';
import _ from 'lodash';

import { ADD_ALERT, REMOVE_ALERT, CLEAR_ALERTS } from './action-types';

const logErrors = true;


export const actions = { addAlert, removeAlert, clearAlerts };
export const alerts = { success, error, warning, catchError };

// Actions
export function addAlert(options) {
  options.id = _.uniqueId();
  
  if (options.expires) {
    options.timeout = window.setTimeout(() => removeAlert(options.id), options.expires * 1000);
  }

  store.dispatch({
    type: ADD_ALERT,
    alert: options
  });
}

export function removeAlert(alertId) {
  store.dispatch({
    type: REMOVE_ALERT,
    alertId
  });
}

export function clearAlerts() {
  store.dispatch({
    type: CLEAR_ALERTS
  });
}


// Shorthand for different types of alert
// Error
export function error(options) {
  const defaults = {
    type: 'danger',
    title: 'Error'
  };

  addAlert(_.defaultsDeep({}, options, defaults));
}

// Rest catch error
export function catchError(err, options) {
  if (logErrors) console.error(err);

  const defaults = {
    type: 'danger',
    title: 'Error',
    subtitle: 'Try again in a few minutes or refresh the page.'
  };

  addAlert(_.defaultsDeep({}, options, defaults));
}

// Warning
export function warning(options) {
  const defaults = {
    type: 'warning',
    title: 'Warning'
  };

  addAlert(_.defaultsDeep({}, options, defaults));
}

// Success
export function success(options) {
  const defaults = {
    type: 'success',
    title: 'Success',
    expires: 15
  };

  addAlert(_.defaultsDeep({}, options, defaults));
}
